/**
 * A `YYYY-MM-DD` calendar day as the local-midnight `Date` the picker works
 * in. react-datepicker reads calendar cells from local dates, so the day must
 * be built from its parts, never parsed as an instant.
 */
export function dateFromDay(day: string): Date {
  const [year, month, date] = day.split("-").map(Number);
  return new Date(year, month - 1, date);
}

/** The calendar day a picker `Date` stands for, as `YYYY-MM-DD`. */
export function dayFromDate(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
}
